import { PackageTemplate } from "@raskrask-dk/raskrask-utils";
import type PackageState from "..";
import {Action} from "../../../action/action";

const SET_PACKAGETEMPLATE = "SET_PACKAGETEMPLATE";
export class SetPackageTemplate extends Action<typeof SET_PACKAGETEMPLATE, PackageTemplate> {
  readonly type = SET_PACKAGETEMPLATE;
  protected state: PackageState;

  constructor(state: PackageState, packageTemplate?: PackageTemplate) {
    super(state, packageTemplate);
    this.state = state;
  }

  public isValid = (): boolean => {
    if (this._data === undefined) return this.isDoable();
    const isMultiplierPositive = this._data.multiplier > 0;
    const isServiceMatching = this.state.service?.id === undefined || this._data.service.id === this.state.service?.id;
    const areValuesOK = isMultiplierPositive && isServiceMatching;
    return areValuesOK && this.isDoable();
  };

  public isDoable = (): boolean => {
    return true;
  };
}
